import React, { useState, useEffect } from 'react';
import { getApiUrl } from '../../config/api';

const ApiDebug = () => {
  const [debugInfo, setDebugInfo] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const testApis = async () => {
      const results = {};
      
      try {
        // Test products API
        console.log('Testing products API...');
        const productsResponse = await fetch(getApiUrl('/gold'));
        const productsData = await productsResponse.json();
        results.products = {
          status: productsResponse.status,
          count: productsData.count || productsData.length || 0,
          data: productsData
        };
        console.log('Products API result:', results.products);
      } catch (error) {
        results.products = { error: error.message };
        console.error('Products API error:', error);
      }

      try {
        // Test categories API
        console.log('Testing categories API...');
        const categoriesResponse = await fetch(getApiUrl('/category/getAllCategory'));
        const categoriesData = await categoriesResponse.json();
        results.categories = {
          status: categoriesResponse.status,
          count: categoriesData.data?.length || categoriesData.length || 0,
          data: categoriesData
        };
        console.log('Categories API result:', results.categories);
      } catch (error) {
        results.categories = { error: error.message };
        console.error('Categories API error:', error);
      }

      try {
        // Test features API
        console.log('Testing features API...');
        const featuresResponse = await fetch(getApiUrl('/features'));
        const featuresData = await featuresResponse.json();
        results.features = {
          status: featuresResponse.status,
          count: featuresData.length || 0,
          data: featuresData
        };
        console.log('Features API result:', results.features);
      } catch (error) {
        results.features = { error: error.message };
        console.error('Features API error:', error);
      }

      setDebugInfo(results);
      setLoading(false);
    };

    testApis();
  }, []);

  if (loading) {
    return <div className="p-4">Loading debug info...</div>;
  }

  return (
    <div className="p-4 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">API Debug Information</h1>
      
      <div className="space-y-4">
        <div className="bg-white p-4 rounded shadow">
          <h2 className="text-lg font-semibold mb-2">Products API</h2>
          <pre className="bg-gray-100 p-2 rounded text-sm overflow-auto">
            {JSON.stringify(debugInfo.products, null, 2)}
          </pre>
        </div>

        <div className="bg-white p-4 rounded shadow">
          <h2 className="text-lg font-semibold mb-2">Categories API</h2>
          <pre className="bg-gray-100 p-2 rounded text-sm overflow-auto">
            {JSON.stringify(debugInfo.categories, null, 2)}
          </pre>
        </div>

        <div className="bg-white p-4 rounded shadow">
          <h2 className="text-lg font-semibold mb-2">Features API</h2>
          <pre className="bg-gray-100 p-2 rounded text-sm overflow-auto">
            {JSON.stringify(debugInfo.features, null, 2)}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default ApiDebug;
